import styled from "styled-components";

export const Dots = styled.div``;
